module.exports = __webpack_public_path__ + "img/clouds.50439d40.png";